import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { AddLineButton } from './add-line-button';
import { ADDRESS_FIELDS, ADDRESS_LINE_TEMPLATE } from './address-fields.config';

import styles from './AddressQuestion.scss';
import { AddressQuestionInput } from './input';

export class AddressQuestion extends PureComponent {
  state = {
    currentAddressLines: 2,
    maxAddressLines: 4,
    isAddButtonVisible: true,
    addressFields: ADDRESS_FIELDS,
  };

  initialAddressLines = 2;

  componentDidMount() {
    const { definition } = this.props;

    const addressLines = Object.entries(definition)
      .filter(([, value]) => value.length !== 0)
      .map(([key]) => parseInt(key.substring('addressLine'.length), 10))
      .filter((key) => !Number.isNaN(key));
    const currentAddressLines = Math.max(...addressLines, this.initialAddressLines);

    const linesToAdd = currentAddressLines - this.initialAddressLines;
    if (linesToAdd !== 0) {
      this.addAddressLines(linesToAdd);
    }
  }

  addAddressLines = (count) => {
    const { currentAddressLines, maxAddressLines, addressFields } = this.state;

    const newAddressFields = [...addressFields];
    const newCurrentAddressLines = currentAddressLines + count;
    const lines = [];
    for (let i = 0; i < count; i += 1) {
      lines.push(ADDRESS_LINE_TEMPLATE(currentAddressLines + i + 1));
    }

    newAddressFields.splice(currentAddressLines, 0, ...lines);
    this.setState({
      addressFields: newAddressFields,
      currentAddressLines: newCurrentAddressLines,
      isAddButtonVisible: newCurrentAddressLines < maxAddressLines,
    });
  };

  addAddressLinesHandler = () => {
    this.addAddressLines(1);
  };

  render() {
    const {
      reduxFieldConfig: { name },
      definition,
    } = this.props;
    const { addressFields, isAddButtonVisible } = this.state;

    return (
      <div data-testid="AddressQuestion" className={styles.AddressQuestion}>
        {addressFields.map((fieldConfig) => {
          const displayButton = fieldConfig.showButtonAbove && isAddButtonVisible;
          const fieldName = `${name}.${fieldConfig.name}`;

          return (
            <Fragment key={fieldConfig.name}>
              {displayButton && <AddLineButton onClickHandler={this.addAddressLinesHandler} />}
              <Field
                name={fieldName}
                render={({ input, meta }) => (
                  <AddressQuestionInput
                    {...fieldConfig}
                    input={input}
                    meta={meta}
                    fieldName={fieldConfig.name}
                    element={fieldConfig.component}
                    definition={definition[fieldConfig.name]}
                  />
                )}
              />
            </Fragment>
          );
        })}
      </div>
    );
  }
}

AddressQuestion.propTypes = {
  reduxFieldConfig: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  definition: PropTypes.shape({}).isRequired,
};
